import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { schemas } from '@convergence/client';

export function useLogsQuery(analysisSlug: string) {
  return useQuery({
    queryKey: ['logs', analysisSlug],
    refetchInterval: 5000,
    queryFn: async () => {
      return fetch(
        `/analysis/${analysisSlug}/logs`,
        {
          method: 'GET'
        },
        schemas.AnalysisLogsDto
      );
    }
  });
}
